export default __webpack_public_path__ + "images/1c00c716fa282f719ba304cf390c316c-shop-pay.svg";